<template>
  <v-dialog fullscreen value="true" persistent transition="dialog-bottom-transition">
    <v-card>
      <Toolbar title="Channel Data Integrations" @close="handleCancel" />

      <div class="pa-3">
        <v-tabs v-model="tab" color="brand">
          <v-tab key="dashboard" @click="handleOpenDashboard"> Dashboard </v-tab>
          <!-- <v-tab key="workflow" @click="handleOpenWorkflow">
            Workflow
          </v-tab> -->
          <v-tab key="marketplace" @click="handleOpenMarketplace"> Marketplace </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <!--TODO: if tab logic gets more complex or there are more tabs, consider refactoring -->
          <v-tab-item key="dashboard" class="prismatic-tab">
            <div
              id="dashboard-container"
              class="prismatic-container"
              :style="{
                height: containerHeight ? containerHeight + 'px' : '300px',
              }"
            ></div>
            <v-progress-linear v-if="isLoading" indeterminate color="brandPrimary" class="mb-2" />
          </v-tab-item>
          <!--<v-tab-item key="workflow" class="prismatic-tab">
          <div id="workflow-container" class="prismatic-container" :style="{ height: containerHeight ? containerHeight + 'px' : '300px' }"></div>
       </v-tab-item>-->
          <v-tab-item key="marketplace" class="prismatic-tab">
            <div
              id="marketplace-container"
              class="prismatic-container"
              :style="{
                height: containerHeight ? containerHeight + 'px' : '300px',
              }"
            ></div>
            <v-progress-linear v-if="isLoading" indeterminate color="brandPrimary" class="mb-2" />
          </v-tab-item>
        </v-tabs-items>
        <div></div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import prismatic from "@prismatic-io/embedded";
import PrismaticTokenService from "@/services/PrismaticTokenService";
import Toolbar from "@/components/generic/Toolbar.vue";

export default {
  name: "ChannelDataIntegrations",
  props: {},
  components: {
    Toolbar,
  },
  data() {
    return {
      tab: 0,
      prismaticAuthenticated: false,
      authenticatingPrismatic: false,
      containerHeight: null,
      isLoading: false,
    };
  },

  mounted() {
    prismatic.init();
    this.handleOpenDashboard();
  },
  methods: {
    async handleOpenMarketplace() {
      this.tab = 1;
      await this.$nextTick();
      await this.setContainerHeight("marketplace");
      await this.authenticatePrismatic();
      prismatic.showMarketplace({
        selector: "#marketplace-container",
      });
    },
    //https://prismatic.io/docs/embed/workflow-builder/workflow-builder/
    async handleOpenDashboard() {
      this.tab = 0;
      await this.$nextTick();
      await this.setContainerHeight("dashboard");
      await this.authenticatePrismatic();
      prismatic.showDashboard({
        selector: "#dashboard-container",
      });
    },
    // leave for now until we decide to enable workflow tab
    async handleOpenWorkflow() {
      this.tab = 1;
      await this.$nextTick();
      await this.setContainerHeight("workflow");
      await this.authenticatePrismatic();
      prismatic.showWorkflows({
        selector: "#workflow-container",
      });
    },
    async authenticatePrismatic() {
      if (this.prismaticAuthenticated || this.authenticatingPrismatic) return;

      this.authenticatingPrismatic = true;
      this.isLoading = true;
      try {
        const token = await this.getJwtToken();

        if (!token) {
          throw new Error("Prismatic authentication failed: missing token");
        }
        await prismatic.authenticate({ token });
        this.prismaticAuthenticated = true;
        console.log("Prismatic authenticated successfully");
      } catch (error) {
        console.error(`Authentication failed with error ${error}`);

        this.$store.dispatch("showSnackbar", {
          text: "We are experiencing technical difficulties. Please try again later.",
          color: "error",
        });
        this.handleCancel();
      } finally {
        this.authenticatingPrismatic = false;
        this.isLoading = false;
      }
    },
    async getJwtToken() {
      return await PrismaticTokenService.getJwtToken();
    },

    // Created a workaround to dynamically set the height of the iframe containers
    async setContainerHeight(name) {
      await this.$nextTick();
      const id = `${name}-container`;
      const el = document.getElementById(id);
      if (!el) return;

      let parent = el.parentElement;
      let height = parent && parent.clientHeight ? parent.clientHeight : 0;

      if (!height || height < 200) {
        height = Math.floor(window.innerHeight * 0.6);
      }

      const toolbar = this.$el ? this.$el.querySelector(".v-toolbar") : null;
      const toolbarHeight = toolbar ? toolbar.clientHeight : 64;
      const finalHeight = Math.max(300, Math.floor(height - toolbarHeight - 100));

      this.containerHeight = finalHeight;
    },
    handleCancel() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.prismatic-tab {
  display: flex;
  flex-direction: column;
  min-height: 82vh;
}

.prismatic-container {
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
